export const RowLabel = ({ label }: { label: string }) => {
  return <h1 className="font-medium text-sm w-1/4">{label}</h1>;
};
export const RowWrapper = ({ children, styles }: { children: JSX.Element | JSX.Element[]; styles?: string }) => {
  return <div className={`flex flex-row gap-x-2 items-center w-full ${styles}`}>{children}</div>;
};
export const RowWrapperHalfSpan = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
  return <div className="flex flex-row w-1/2 items-center justify-between">{children}</div>;
};
